export const BACKEND_URI = "https://e-learning-backends.onrender.com";
